import { doc, updateDoc, writeBatch } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { db } from "../../firebase";
import { InvoiceData } from "../../redux/types";
import { getInvoicesAPi } from "./rest-api";

const functions = getFunctions();

export function invoicesListner(cb: (invoices: InvoiceData[]) => void) {
  getInvoicesAPi().then(cb);
}

// Traitement comptable GROUPÉ de dépenses. « traiter » est un simple drapeau
// sur la dépense : aucun déclencheur ne réagit à sa mise à jour, rien ne part
// vers la plateforme ni vers l'utilisateur.
// writeBatch applique un lot tout ou rien, en un aller-retour : une coupure
// réseau ne laisse pas une sélection à moitié traitée. Firestore limite un lot
// à 500 écritures ; au-delà, chaque tranche reste atomique, pas l'ensemble.
export async function setInvoicesTraiterAsync(
  uids: string[],
  traiter: boolean,
) {
  for (let i = 0; i < uids.length; i += 500) {
    const batch = writeBatch(db);
    for (const uid of uids.slice(i, i + 500)) {
      batch.update(doc(db, "invoices", uid), { traiter });
    }
    await batch.commit();
  }
}

export async function updateFactStatutAsync(
  uid?: string,
  data?: Partial<InvoiceData>,
) {
  if (!uid) return;
  return await updateDoc(doc(db, "invoices", uid), data);
}

export async function sendInvoiceComment({ invoiceId, comment }) {
  const callable = httpsCallable(functions, "sendInvoiceComment");
  const invoiceComment = await callable({ invoiceId, comment });

  return invoiceComment;
}

export async function sendResponseContact({ messageId, response }) {
  const callable = httpsCallable(functions, "sendResponseContact");
  const responseComment = await callable({ messageId, response });

  return responseComment;
}
